import Vue from 'vue'
import App from './App.vue'
import router from './router'
//must also import need plugins
import { TweenMax, CSSPlugin} from 'gsap/all'

// counteract tree shaking in webpack for gsap plugins
const plugins = [CSSPlugin]
testPlugins();

function testPlugins(){
  if(plugins){
    return true;
  }
}



//import './styles/index.css'



Vue.config.productionTip = false

// import io from 'socket.io-client'
// //use .env file to insert correct ip for socket client resources
//
//
// var socket = io.connect(APP_SOCKET_IP);
//
// Vue.prototype.$socket = socket;


Vue.prototype.$tween = TweenMax;



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
